import config from '../config.js'
import UserAuthentication from '@/auth'

import { HTTP } from './helpers/http'
import qs from 'qs'

const ORGANIZATION_TOKENS_LIMIT = null

export default {
  getSummary(organizationId, modelName, modelId) {
    const auth = new UserAuthentication(window.localStorage)
    const authToken = auth.getAccessToken()

    const url = `/api/v1/organizations/${organizationId}/${modelName}/${modelId}/summary`

    return fetch(`${config.api}${url}`, {
      headers: {
        'Content-Type': 'application/json',
        Authorization: authToken,
      },
    })
  },

  getTasks(organizationId, modelName, modelId) {
    return HTTP.get(
      `/api/v1/organizations/${organizationId}/${modelName}/${modelId}/task-suggestions`
    )
  },

  getSolution(organizationId, modelName, modelId) {
    return HTTP.get(
      `/api/v1/organizations/${organizationId}/${modelName}/${modelId}/solution-suggestions`
    )
  },

  getBalance(organizationId) {
    return HTTP.get(`/api/v1/organizations/${organizationId}/ai-tokens/balance`)
  },

  getOrganizationAISettings(organizationId) {
    return HTTP.get(`/api/v1/organizations/${organizationId}/ai-settings`)
  },

  updateOrganizationAISettings(organizationId, settings) {
    return HTTP.put(
      `/api/v1/organizations/${organizationId}/ai-settings`,
      settings
    )
  },

  depositTokens(organizationId, tokens, trackingNumber) {
    return HTTP.post(`/api/v1/organizations/${organizationId}/ai-tokens`, {
      tokens,
      trackingNumber,
    })
  },

  getTokensUsage(organizationId, year) {
    return HTTP.get(`/api/v1/organizations/${organizationId}/ai-tokens/usage`, {
      params: {
        year,
      },
    })
  },

  getDeposits(organizationId, options = {}) {
    const params = {
      params: options,
      paramsSerializer(parameters) {
        return qs.stringify(parameters, { arrayFormat: 'brackets' })
      },
    }
    return HTTP.get(
      `/api/v1/organizations/${organizationId}/ai-tokens/deposits`,
      params
    )
  },

  grantAccessToAIFeatures(organizationId, accountIds) {
    return HTTP.post(
      `/api/v1/organizations/${organizationId}/ai-settings/accounts/bulk`,
      {
        operation: 'patch',
        accounts: accountIds.map(id => ({
          id,
          tokens: ORGANIZATION_TOKENS_LIMIT,
        })),
      }
    )
  },

  grantSitesAccessToAIFeatures(organizationId, siteIds) {
    return HTTP.post(
      `/api/v1/organizations/${organizationId}/ai-settings/sites/bulk`,
      {
        operation: 'patch',
        sites: siteIds.map(id => ({
          id,
        })),
      }
    )
  },

  updateAccountMonthlyTokensLimit(organizationId, accountId, monthlyLimit) {
    return HTTP.patch(
      `/api/v1/organizations/${organizationId}/ai-settings/accounts/${accountId}`,
      { tokens: monthlyLimit }
    )
  },

  deleteAccountAISettings(organizationId, accountId) {
    return HTTP.delete(
      `/api/v1/organizations/${organizationId}/ai-settings/accounts/${accountId}`
    )
  },

  deleteSiteAISettings(organizationId, siteId) {
    return HTTP.delete(
      `/api/v1/organizations/${organizationId}/ai-settings/sites/${siteId}`
    )
  },

  getTokensAvailability(organizationId) {
    return HTTP.get(
      `/api/v1/organizations/${organizationId}/ai-tokens/availability`
    )
  },

  createNewChat(organizationId, payload = {}) {
    return HTTP.post(
      `/api/v1/organizations/${organizationId}/ai-agents/chats`,
      payload
    )
  },

  getChats(organizationId, options = {}) {
    const params = {
      params: options,
      paramsSerializer(parameters) {
        return qs.stringify(parameters, { arrayFormat: 'brackets' })
      },
    }
    return HTTP.get(
      `/api/v1/organizations/${organizationId}/ai-agents/chats/`,
      params
    )
  },

  deleteChat(organizationId, chatId) {
    return HTTP.delete(
      `/api/v1/organizations/${organizationId}/ai-agents/chats/${chatId}`
    )
  },

  getChatMessages(organizationId, chatId, options = {}) {
    return HTTP.get(
      `/api/v1/organizations/${organizationId}/ai-agents/chats/${chatId}/messages`,
      { params: options }
    )
  },

  postMessage(organizationId, payload, signal) {
    const auth = new UserAuthentication(window.localStorage)
    const authToken = auth.getAccessToken()

    const url = `/api/v1/organizations/${organizationId}/ai-agents/chats/messages`

    return fetch(`${config.api}${url}`, {
      body: JSON.stringify(payload),
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Authorization: authToken,
      },
      signal,
    })
  },
}
